




import { Component, Vue } from 'vue-property-decorator';

@Component
export default class IIIFViewer extends Vue {
  mounted() {
    this.$nextTick(() => {
      this.initViewer();
    });
  }

  initViewer() {
    (window as any).UV.init('uv', {
      manifest: 'https://v2.honkoku.org/manifests/supvol10.json',
      embedded: true
    });
  }
}
